import React, { useState } from 'react';
import SettingsWrapper from '../../../layout/SettingsWrapper';
import Kyc from './Kyc';
import Kyb from './Kyb';

const Verification = () => {


      const [type, settype] = useState('kyb');

      function changeType(e) {
            settype(e);
      }

      return (
            <SettingsWrapper
                  title="VERIFICATION">

                  {/* Select buttons for kyc or kyb */}

                  <div
                        className="d-flex justify-content-between mx-auto mt-4 px-2 py-2 pry-border transparent br-sm fit-content">
                        <div
                              className={`col br-sm py-1 pry-text pointer text-center px-5 ${ type === 'kyc' ? 'pry light-text ' : ('') } `}
                              onClick={e => changeType('kyc')}
                        >
                              KYC
                        </div>
                        <div
                              className={`col br-sm py-1 pry-text pointer text-center px-5 ${ type === 'kyb' ? 'pry light-text' : ('') } `}
                              onClick={e => changeType('kyb')}
                        >
                              KYB
                        </div>
                  </div>

                  {type === 'kyc' ?
                        <Kyc
                        /> :
                        <Kyb
                        />
                  }


            </SettingsWrapper>

      );
};

export default Verification;